export default __webpack_public_path__ + "static/media/japan.089566f1.svg";